import { computed, DestroyRef, effect, inject, Injector, model, runInInjectionContext } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CrudUiFrontendSharedModule } from '@common/crud-ui/frontend-shared';
import { CrudFormServiceFactory } from '@common/crud/frontend-shared';
import { BaseFormService } from '@common/forms/frontend-shared';
import { vttCueNodeObjectNames, VttCueTreeModel } from '@common/media/shared';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { UiContentCenteredComponent } from '@common/ui/frontend-shared/content-centered';
import { UiFieldWrapperComponent } from '@common/ui/frontend-shared/field-wrapper';
import { UiInputGroupComponent } from '@common/ui/frontend-shared/input-group';
import { UiInputTextareaComponent } from '@common/ui/frontend-shared/input-textarea';
import { UiMessageComponent } from '@common/ui/frontend-shared/message';
import { DurationPipe, takeWhileAlive } from '@core/frontend-shared';
import { distinctUntilChangedDeep, getDiff } from '@core/shared/utils';
import { debounceTime } from 'rxjs';
import { TimelineService } from '../media-asset-timeline/timeline.service';
import * as i0 from "@angular/core";
import * as i1 from "@common/crud/frontend-shared";
import * as i2 from "@angular/forms";
import * as i3 from "../../../../../../forms/frontend-shared/src/lib/form-submit-button/form-submit-button.directive";
import * as i4 from "../../../../../../crud-ui/frontend-shared/src/lib/crud-fieldset/crud-fieldset.component";
import * as i5 from "../../../../../../forms/frontend-shared/src/lib/array-fieldset/array-fieldset";
const _c0 = a0 => [a0, "children"];
function MediaAssetSubtitlesCueEditorComponent_Conditional_0_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ui-message", 7);
    i0.ɵɵtext(1, " Der Inhalt dieses Untertitels wurde vereinfacht, da der Editor nicht den gesamten VTT-Standard unterst\u00FCtzt. ");
    i0.ɵɵelementEnd();
  }
}
function MediaAssetSubtitlesCueEditorComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "h3", 4);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "duration");
    i0.ɵɵpipe(4, "duration");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "ui-input-group");
    i0.ɵɵelement(6, "button", 5);
    i0.ɵɵelementStart(7, "button", 6);
    i0.ɵɵlistener("click", function MediaAssetSubtitlesCueEditorComponent_Conditional_0_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onClickDelete());
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵconditionalCreate(8, MediaAssetSubtitlesCueEditorComponent_Conditional_0_Conditional_8_Template, 2, 0, "ui-message", 7);
    i0.ɵɵelement(9, "crud-fieldset", 8);
  }
  if (rf & 2) {
    const item_r3 = ctx;
    const ctx_r1 = i0.ɵɵnextContext();
    const contentEditor_r4 = i0.ɵɵreference(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" Untertitel ", i0.ɵɵpipeBind2(3, 6, item_r3.start, "mm:ss:mmm"), " - ", i0.ɵɵpipeBind2(4, 9, item_r3.end, "mm:ss:mmm"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("formSubmitButton", ctx_r1.formService);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.contents().hasNonTextNodes ? 8 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formService", ctx_r1.formService)("innerForm", contentEditor_r4);
  }
}
function MediaAssetSubtitlesCueEditorComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ui-content-centered", 2)(1, "p", 9);
    i0.ɵɵtext(2, "Bitte ein Item in der Timeline w\u00E4hlen!");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵproperty("vCenter", true);
  }
}
function MediaAssetSubtitlesCueEditorComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelement(1, "array-fieldset", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const formGroup_r5 = ctx.formGroup;
    const formService_r6 = ctx.formService;
    i0.ɵɵnextContext();
    const nodeEditor_r7 = i0.ɵɵreference(5);
    i0.ɵɵproperty("formGroup", formGroup_r5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("controlFormServiceChildProp", i0.ɵɵpureFunction1(4, _c0, formService_r6))("innerForm", nodeEditor_r7)("reordering", true);
  }
}
function MediaAssetSubtitlesCueEditorComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "ui-field-wrapper", 13);
    i0.ɵɵelement(2, "ui-input-textarea", 14);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const formGroup_r8 = ctx.formGroup;
    i0.ɵɵproperty("formGroup", formGroup_r8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("placeholder", "Untertitel Text")("hidePlaceholder", false);
  }
}
export let MediaAssetSubtitlesCueEditorComponent = /*#__PURE__*/(() => {
  class MediaAssetSubtitlesCueEditorComponent {
    // timeline listens to space keypress globally. stop propagation to not trigger it while working in editor!
    handleKeypress(event) {
      event.stopPropagation();
    }
    constructor(formServiceFactory) {
      this.formServiceFactory = formServiceFactory;
      this.destroyRef = inject(DestroyRef);
      this.injector = inject(Injector);
      this.vttCueNodeObjectNames = vttCueNodeObjectNames;
      this.item = model(null, ...(ngDevMode ? [{
        debugName: "item"
      }] : /* istanbul ignore next */[]));
      this.contents = computed(() => {
        const item = this.item();
        if (!item) return {
          hasNonTextNodes: false,
          nodes: []
        };
        let nodes = item.data.tree.children;
        const hasNonTextNodes = nodes.some(c => c.type !== 'text');
        if (hasNonTextNodes) {
          nodes = reduceComplexTree(nodes);
        }
        // console.log(item.data.tree.children, nodes)
        return {
          hasNonTextNodes,
          nodes
        };
      }, ...(ngDevMode ? [{
        debugName: "contents"
      }] : /* istanbul ignore next */[]));
      this._contentsChange = effect(() => {
        const prevValue = this.formService.getValue();
        const content = this.contents();
        const updatedValue = {
          children: content.nodes
        };
        if (prevValue) {
          const diff = getDiff(updatedValue, prevValue);
          // console.log('contentschange diff',diff)
          const hasChanges = Object.keys(diff).length > 0;
          if (!hasChanges) return;
        }
        if (this.formService.initialized) {
          this.formService.resetForm({
            value: updatedValue
          });
        } else {
          this.formService.setInitialValue(updatedValue);
        }
      }, ...(ngDevMode ? [{
        debugName: "_contentsChange"
      }] : /* istanbul ignore next */[]));
      this.formService = this.formServiceFactory.useDestroyRef(this.destroyRef).createModelForm(VttCueTreeModel);
      this.formService.setSaveHandler('noop');
      this.formService.setModel(VttCueTreeModel);
      this.formService.setEditorDefinition('admin');
      this.formService.setEditMode('edit');
      this.formService.initialize();
      this.formService.setSaveHandlerFunction((vttEntryModel, fs) => {
        const item = this.item();
        if (!item) return;
        const patch = {
          data: {
            tree: {
              children: vttEntryModel.children
            }
          }
        };
        this.timeline.updateItem(item.id, patch);
        // this.timeline.selectItem(null);
      });
      // this.formService.valueChanges$.pipe(
      // 	debounceTime(50),
      // 	distinctUntilChangedDeep({makeImmutable:true}),
      // 	takeWhileAlive(),
      // ).subscribe((vttEntryModel) => {
      // })
      this.formService.state$.pipe(distinctUntilChangedDeep({
        makeImmutable: true
      }), takeWhileAlive(), debounceTime(500)).subscribe(state => {
        if (state.isChanged && state.valid && !state.busy) {
          this.formService.save();
        }
      });
    }
    ngOnInit() {
      runInInjectionContext(this.injector, () => {
        // TODO: code flow direction is a problem. updating an item will asynchronously trigger a re-emit of selectedItem.
        toObservable(this.timeline.selectedItem).pipe(takeWhileAlive(this.destroyRef)).subscribe(item => {
          this.item.set(item);
        });
      });
    }
    onClickAbort() {
      this.timeline.selectItem(null);
    }
    onClickDelete() {
      this.timeline.deleteItem(this.item());
    }
    static {
      this.ɵfac = function MediaAssetSubtitlesCueEditorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MediaAssetSubtitlesCueEditorComponent)(i0.ɵɵdirectiveInject(i1.CrudFormServiceFactory));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: MediaAssetSubtitlesCueEditorComponent,
        selectors: [["media-asset-subtitles-cue-editor"]],
        hostBindings: function MediaAssetSubtitlesCueEditorComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keypress", function MediaAssetSubtitlesCueEditorComponent_keypress_HostBindingHandler($event) {
              return ctx.handleKeypress($event);
            });
          }
        },
        inputs: {
          timeline: "timeline",
          item: [1, "item"]
        },
        outputs: {
          item: "itemChange"
        },
        decls: 6,
        vars: 1,
        consts: [["contentEditor", ""], ["nodeEditor", ""], [3, "vCenter"], [1, "header", "ui-margin"], [1, "ui-margin-remove"], ["uiButton", "", 3, "formSubmitButton"], ["uiButton", "", "label", "l\u00F6schen", "icon", "trash", 1, "ui-button-danger", 3, "click"], ["type", "warning"], [3, "formService", "innerForm"], [1, "color-grey"], [1, "ui-form-theme-invisible", 3, "formGroup"], ["buttonLabel", "hinzuf\u00FCgen", 3, "controlFormServiceChildProp", "innerForm", "reordering"], [3, "formGroup"], [3, "placeholder", "hidePlaceholder"], ["formControlName", "value", 1, "ui-width-stretch"]],
        template: function MediaAssetSubtitlesCueEditorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, MediaAssetSubtitlesCueEditorComponent_Conditional_0_Template, 10, 12)(1, MediaAssetSubtitlesCueEditorComponent_Conditional_1_Template, 3, 1, "ui-content-centered", 2);
            i0.ɵɵtemplate(2, MediaAssetSubtitlesCueEditorComponent_ng_template_2_Template, 2, 6, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, MediaAssetSubtitlesCueEditorComponent_ng_template_4_Template, 3, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            let tmp_2_0;
            i0.ɵɵconditional((tmp_2_0 = ctx.item()) ? 0 : 1, tmp_2_0);
          }
        },
        dependencies: [UiButtonComponent, UiMessageComponent, ReactiveFormsModule, i2.NgControlStatus, i2.NgControlStatusGroup, i2.FormGroupDirective, i2.FormControlName, FormsModule, UiFieldWrapperComponent, UiInputTextareaComponent, CrudUiFrontendSharedModule, i3.FormSubmitButtonDirective, i4.CrudFieldsetComponent, i5.ArrayFieldset, UiInputGroupComponent, UiContentCenteredComponent, DurationPipe],
        styles: [".header[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:space-between}\n\n/*# sourceMappingURL=media-asset-subtitles-cue-editor.component.ts-angular-inline--80.css.map*/"],
        changeDetection: 0
      });
    }
  }
  return MediaAssetSubtitlesCueEditorComponent;
})();
function collectText(n) {
  const pieces = [];
  for (const child of n.children) {
    if (child.type === 'text') pieces.push(child.value);
    if (child.type === 'object') pieces.push(collectText(child));
  }
  return pieces.join("\n");
}
function reduceComplexTree(nodes) {
  const out = [];
  nodes.forEach(n => {
    if (n.type === 'text') out.push(n);
    if (n.type === 'object') {
      const text = collectText(n);
      out.push({
        type: 'text',
        value: text
      });
    }
  });
  return out;
}